// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__AAD6R","EnvWarning":"Logo_EnvWarning__2WFZI"};